import { BAND_STYLE, overallBand, levelStyle } from "@/lib/scale";

export function BandPill({ bandKey, label, testId }) {
  const s = BAND_STYLE[bandKey] || BAND_STYLE.emerging;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold font-['Outfit'] ${s.bg} ${s.text}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${s.dot}`} />
      {label}
    </span>
  );
}

export function ScoreRing({ total, size = 64 }) {
  const band = overallBand(total);
  const s = BAND_STYLE[band.key];
  const pct = Math.min(100, (total / 45) * 100);
  const stroke = 5;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#EEF0EE" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={s.solid}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={c - (pct / 100) * c}
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="font-['Outfit'] font-bold text-slate-800 leading-none text-base">{total}</span>
        <span className="text-[9px] text-slate-400 leading-none mt-0.5">/45</span>
      </div>
    </div>
  );
}

export function LevelChip({ level }) {
  const s = levelStyle(level);
  return (
    <span
      className="inline-flex items-center justify-center h-7 w-7 rounded-lg text-sm font-bold font-['Outfit'] text-white"
      style={{ backgroundColor: s.solid }}
    >
      {level}
    </span>
  );
}
